<script setup lang="ts">
  const props = defineProps({
    items: {
      type: Array as PropType<any[]>,
      required: true,
      default: () => [],
    },
    keyName: {
      type: String,
      required: false,
    },
    setting: {
      type: Object,
      default: () => {
        return {
          initialItemsNumber: 10,
          revealNumberPerClick: 6,
        }
      },
    },
  })

  const revealItemsPerAction = ref(props.setting.initialItemsNumber)
  const revealedItems = computed(() => props.items.slice(0, revealItemsPerAction.value))
  const viewMore = () => {
    revealItemsPerAction.value = revealItemsPerAction.value + props.setting.revealNumberPerClick
    // revealedItems.value = revealedItems.value + revealItemsPerAction.value
  }

  // mock remote data fetching
</script>
<template>
  <div class="view-more-items">
    <TransitionGroup name="list">
      <span
        v-for="(item, index) in revealedItems"
        :key="props.keyName ? `${index}-${item[props.keyName]}` : index"
        class="view-more-items__item"
      >
        <slot name="item" v-bind="item" />
      </span>
    </TransitionGroup>
  </div>
  <div
    v-if="props.setting.initialItemsNumber < props.items.length && revealedItems.length != props.items.length"
    class="view-more-items__button"
    @click="viewMore"
  >
    <div class="view-more-items__button-text font2">View More</div>
    <div class="view-more-items__button-icon"></div>
  </div>
</template>
<style scoped lang="scss">
  .list-enter-active {
    transition: all 0.5s ease;
  }

  .list-enter-from {
    opacity: 0;
    transform: translateX(30px);
  }

  /* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
  .list-leave-active {
    position: absolute;
  }
  .view-more-items__button {
    display: block;
    width: 150px;
    margin: 0 auto 25px;
    text-align: center;
  }
  .view-more-items__button-icon {
    width: 20px;
    height: 20px;
    display: inline-block;
    background: url('@/assets/imgs/components/ViewMoreItems/trianble-icon.png') no-repeat center center/ 100% auto;
  }
  .view-more-items__button-text {
    font-size: 20px;
    line-height: 1em;
    text-transform: uppercase;
    font-weight: bold;
  }

  .view-more-items {
    margin-bottom: 20px;
  }
</style>
